import { connect } from 'react-redux';

import { iRootDispatch, iRootState } from '../../store';
import { AvailableBrokersAndEstatesState } from '../../store/types/temp-types';
import BondInsuranceProposalsPage from './components/BondInsuranceProposalsPage';

export type { BondInsuranceProposalsListProps } from './components/BondInsuranceProposalsPage';

const mapState = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates,
  user: state.user
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateAvailableBrokersAndEstates: (availableBrokers: AvailableBrokersAndEstatesState) =>
    dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(availableBrokers)
});

export default connect(mapState, mapDispatch)(BondInsuranceProposalsPage);
